let lockCount = 0;
let previousBodyOverflow = '';
let previousBodyPaddingRight = '';
let previousHtmlOverflow = '';

function lockBodyScroll() {
  if (typeof document === 'undefined') return;

  if (lockCount === 0) {
    const { body, documentElement } = document;
    previousBodyOverflow = body.style.overflow;
    previousBodyPaddingRight = body.style.paddingRight;
    previousHtmlOverflow = documentElement.style.overflow;

    const scrollbarWidth = window.innerWidth - documentElement.clientWidth;
    body.style.overflow = 'hidden';
    documentElement.style.overflow = 'hidden';
    if (scrollbarWidth > 0) {
      body.style.paddingRight = `${scrollbarWidth}px`;
    }
  }

  lockCount += 1;
}

function unlockBodyScroll() {
  if (typeof document === 'undefined' || lockCount === 0) return;

  lockCount -= 1;
  if (lockCount === 0) {
    document.body.style.overflow = previousBodyOverflow;
    document.body.style.paddingRight = previousBodyPaddingRight;
    document.documentElement.style.overflow = previousHtmlOverflow;
  }
}

/**
 * Prevents background/body scrolling while an overlay modal is open.
 * Uses a module-level lock count so nested/stacked modals do not unlock
 * scrolling until the last active modal has closed.
 */
export function useBodyScrollLock(isLocked: () => boolean) {
  // eslint-disable-next-line momentium/no-unguarded-effect -- DOM side effect lifecycle: lock body scroll only while a modal is open, with cleanup on close/destroy
  $effect(() => {
    if (!isLocked()) return;

    lockBodyScroll();
    return unlockBodyScroll;
  });
}
